import { render } from "./RecentLoanApplications.vue?vue&type=template&id=08e65914"
import script from "./RecentLoanApplications.vue?vue&type=script&lang=js"
export * from "./RecentLoanApplications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__